import { Component, OnInit, ViewContainerRef, Inject, ViewChild, TemplateRef } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { MatIconRegistry, MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Response, Headers } from '@angular/http';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, FormControl, Validators, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ValidationService } from '../../../common/validationservice';
import { MainAppComponent } from '../../../layout/layout.component';
import { PagerService } from '../../../common/pagerService';
import { PageResultDto } from '../../../common/viewModels/kyc/CustomerKycViewModel';
import { UserModel, UserRole, ChangePassword } from '../../../common/viewModels/user';
import { ForgotpasswordComponent } from '../forgotpassword/forgotpassword.component';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  lastCloseResult: string;
  actionsAlignment: string;
  dialogRef: MatDialogRef<ForgotpasswordComponent>;
  showPassword: boolean = false;
  currentYear: number = new Date().getFullYear();
  config: MatDialogConfig = {
    disableClose: true,
    panelClass: 'centered-dialog',
    hasBackdrop: true,
    backdropClass: 'dialog-backdrop',
    width: '500px',
    maxWidth: '90vw',
    height: 'auto',
    data: {
      Email: ''
    }
  };


  loginForm: FormGroup;
  submitted: boolean = false;
  errorDiagnostic: string;
  loading = false;
  ss: any;
  error: string = ''
  isHaveAccount: boolean = false;
  source: any[];
  confirmed: any[];
  items: any[] = [
    { id: 1, name: 'Movie 1', url: '' },
    { id: 2, name: 'Movie 2', url: '' },
    { id: 3, name: 'Movie 3', url: '' },
    { id: 4, name: 'Movie 4', url: '' },
    { id: 5, name: 'Movie 5', url: '' }
  ];

  selectedItems: any[] = [{ id: 1, name: 'Movie 1', url: '' }];

  @ViewChild(TemplateRef) template: TemplateRef<any>;

  constructor(public _router: Router, private _mApp: MainAppComponent, private formBuilder: FormBuilder, private _pageSrvc: PagerService, private _http: CustomHttp,
    private _appUrl: ApiUrl, private _route: ActivatedRoute, private _validationService: ValidationService, private _toastrService: ToastrService, public dialog: MatDialog, @Inject(DOCUMENT) doc: any) {
    dialog.afterOpen.subscribe(() => {
      if (!doc.body.classList.contains('no-scroll')) {
        doc.body.classList.add('no-scroll');
      }
    });
    dialog.afterAllClosed.subscribe(() => {
      doc.body.classList.remove('no-scroll');
    });
  }

  ngOnInit() {

    this._mApp.isAuthorize = false;
    this._mApp.HideLoader();
    this._http.logout();
    this.loginForm = this.formBuilder.group({
      UserName: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])],
      Password: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])],
    })
  }

  OPenForgotPasswordDialog() {
    this.dialogRef = this.dialog.open(ForgotpasswordComponent, this.config);
    this.dialogRef.afterClosed().subscribe((result: any) => {
      if (result != "" && result != null && result != undefined) {
        this._mApp.ShowLoader();
        this._http.forgotPassword(this._appUrl.ForgotPassword + result.Email)
          .subscribe(
            data => {
              this._mApp.HideLoader();

              if (data.json().Result != null) {
                this._toastrService.success(data.json().Result, '');
              }
            },
            error => {
              this._mApp.HideLoader();
              this._toastrService.error(error.json().Result, '');
            }
          );
      }
    });

  }
  log(event: any) {

  }

  onSubmit() {
    this.submitted = true;
    this.errorDiagnostic = null;
    var user = this.loginForm.value;
    if (this.loginForm.valid) {
      this._mApp.ShowLoader();
      this._http.login(user)
        .subscribe(result => {

          var userDetails = JSON.parse(localStorage.getItem('UserName'));
          this._mApp.WelcomeName = userDetails.username;
          if (result === true) {
            this._mApp.HideLoader();
            this._mApp.isAuthorize = true;
            this._mApp.GetMenuItems();
            this._mApp.GetUserProfile();
            var data = JSON.parse(localStorage.getItem('currentUser'));
            let curUserDetails = this._mApp.getCurrentUserData(data.token);
            if (curUserDetails.LabIds)
              this._mApp.currentUserLabIds = JSON.parse(curUserDetails.LabIds);
            if (curUserDetails.DefaultCompanyId)
              this._mApp.currentUserDefaultCompanyId = curUserDetails.DefaultCompanyId;
            if (curUserDetails.RoleId)
              this._mApp.roleId = curUserDetails.RoleId;
            if (curUserDetails.UserTypeId)
              this._mApp.userTypeId = curUserDetails.UserTypeId;
            var userData = UserData(data.token);
            // Navigate to dashboard then reload to ensure clean initialization
            this._router.navigate(['/dashboard']).then(() => {
              window.location.reload();
            });
          }
          else {
            this._toastrService.error('Username or password is incorrect');

          }
        },
          error => {

            this._toastrService.error(error.json().error_description);
            this._mApp.HideLoader();
          })
    }
    else {
      this._toastrService.error('Enter username and password');
    }
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

}
function UserData(token: any) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));

}
